var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyCad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136726)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.06641 0.668457H36.9336V30.4332H-7.06641V0.668457Z",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4811 0.668457H25.4597V30.4332H4.4811V0.668457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.196 20.6171L15.3926 24.453H14.606L14.8026 20.6171C14.8055 20.554 14.7944 20.4911 14.7702 20.4329C14.746 20.3748 14.7092 20.3229 14.6627 20.2811C14.6161 20.2393 14.561 20.2087 14.5012 20.1914C14.4415 20.1742 14.3787 20.1708 14.3175 20.1815L10.5633 20.8527L11.0702 19.4303C11.0908 19.3737 11.0934 19.312 11.0778 19.2538C11.0621 19.1956 11.0289 19.1439 10.9828 19.1059L6.87024 15.7189L7.79674 15.2789C7.85935 15.2488 7.90898 15.1965 7.93634 15.1319C7.96371 15.0672 7.96692 14.9946 7.94538 14.9277L7.13248 12.3853L9.50125 12.8965C9.56541 12.9101 9.63225 12.9007 9.69038 12.8699C9.74856 12.8391 9.79445 12.7888 9.82031 12.7276L10.2792 11.6297L12.1279 13.6476C12.1702 13.693 12.2258 13.7232 12.2863 13.7337C12.3469 13.7442 12.4092 13.7344 12.4638 13.7059C12.5185 13.6773 12.5626 13.6315 12.5895 13.5754C12.6164 13.5192 12.6247 13.4556 12.613 13.3943L11.7214 8.71836L13.1506 9.55842C13.1842 9.57842 13.2214 9.5912 13.26 9.59597C13.2986 9.60074 13.3378 9.5974 13.375 9.58615C13.4123 9.57489 13.4469 9.55598 13.4767 9.53057C13.5065 9.50515 13.5309 9.47379 13.5483 9.43842L14.9993 6.5404L16.4503 9.43842C16.4677 9.47379 16.4921 9.50515 16.5219 9.53057C16.5517 9.55598 16.5863 9.57489 16.6236 9.58615C16.6608 9.5974 16.7 9.60074 16.7386 9.59597C16.7772 9.5912 16.8144 9.57842 16.848 9.55842L18.2772 8.71836L17.3856 13.3943C17.374 13.4556 17.3822 13.5192 17.4092 13.5754C17.436 13.6315 17.4801 13.6773 17.5348 13.7059C17.5894 13.7344 17.6517 13.7442 17.7123 13.7337C17.7728 13.7232 17.8284 13.693 17.8707 13.6476L19.7194 11.6297L20.1783 12.7276C20.2042 12.7888 20.25 12.8391 20.3082 12.8699C20.3664 12.9007 20.4332 12.9101 20.4974 12.8965L22.8662 12.3853L22.0532 14.9277C22.0317 14.9946 22.0349 15.0672 22.0623 15.1319C22.0896 15.1965 22.1393 15.2488 22.2019 15.2789L23.1284 15.7189L19.0158 19.1059C18.9697 19.1439 18.9365 19.1956 18.9208 19.2538C18.9052 19.312 18.9078 19.3737 18.9284 19.4303L19.4353 20.8527L15.6811 20.1815C15.6199 20.1708 15.5571 20.1742 15.4974 20.1914C15.4376 20.2087 15.3825 20.2393 15.336 20.2811C15.2894 20.3229 15.2526 20.3748 15.2284 20.4329C15.2042 20.4911 15.1931 20.554 15.196 20.6171Z",
    fill: "#D52B1E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136726"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136726"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 0.617676,
    width: 44,
    height: 29.7647,
    rx: 7.46001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyCad);
export default __webpack_public_path__ + "static/media/Currency=CAD.45075b2a6fa1e6c0cd6ba671690b32a5.svg";
export { ForwardRef as ReactComponent };